import { isFeatureEnabled } from 'owa-feature-flags';

export function isDexLitePaneEnabled() {
    return isFeatureEnabled('mc-officeEditorDexLitePane') || isFeatureEnabled('mc-dexPaneFeatures');
}

export function isEditorIndicatorEnabled() {
    return isFeatureEnabled('mc-editorIndicator') || isFeatureEnabled('mc-dexPaneFeatures');
}

export function isCritiqueFilteringEnabled() {
    return (
        isFeatureEnabled('mc-defaultSettingsNoRefinements') ||
        isFeatureEnabled('mc-dexPaneFeatures')
    );
}

export function isSharedSettingsEnabled() {
    return (
        isFeatureEnabled('mc-officeEditorSharedSettings') || isFeatureEnabled('mc-dexPaneFeatures')
    );
}

export function isSharedSettingsUxEnabled() {
    return (
        isFeatureEnabled('mc-officeEditorPaneSettingsUX') || isFeatureEnabled('mc-dexPaneFeatures')
    );
}
